//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  useLazyQuickSearchQuery,
} from 'api/tickets'

import ModalFormContainer from 'components/Shared/ModalForm/Index'

const AddTicketsForm = ({
  visible, onSubmit, onClose, ticket,
}) => {
  const { t } = useTranslation()
  const [triggerQuickSearch] = useLazyQuickSearchQuery()

  const onLoadFunc = async (inputValue, callback) => {
    const data = await triggerQuickSearch({
      ticketingSystemDisplayId: ticket.ticketingSystemDisplayId,
      currentTicketNumber: ticket.externalId,
      canBeChild: true,
      searchTerm: inputValue,
    }).unwrap()

    const ticketValues = data.tickets?.map(item => ({
      value: item.id,
      shortLabel: item.number,
      label: `${item.number} ${item.title}`,
    })) || []

    callback(ticketValues)
  }

  const fieldParams = [{
    name: 'ticketList',
    label: t('ticketPage.addTicketsForm.ticketList'),
    type: 'selectAsync',
    placeholder: t('ticketPage.addTicketsForm.placeholder'),
    onLoadOptions: onLoadFunc,
    required: true,
    isMultiselect: true,
  }]

  const initialValues = {
    'ticketList': null,
  }

  return (
    <ModalFormContainer
      onClose={onClose}
      visible={visible}
      onSubmit={onSubmit}
      title={t('ticketPage.addTicketsForm.title')}
      fieldParams={fieldParams}
      initialValues={initialValues}
    />
  )
}

AddTicketsForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  ticket: PropTypes.object.isRequired,
}

export default AddTicketsForm
